module.exports = __webpack_public_path__ + "static/media/photos-center.1231a969.jpg";